import React from "react";
import { styled } from "@mui/system";
import MUIMenuList from "@mui/material/MenuList";
import {
  MenuListProps as MenuListPropsMUI,
  MenuListTypeMap
} from "@mui/material/MenuList";
import { ExtendList } from "@mui/material/List";
export interface MenuListProps extends MenuListPropsMUI {}

const MenuListRoot = styled(MUIMenuList, {
  name: "MenuList",
  slot: "Root",
  overridesResolver: (props, styles) => []
})(({ theme }) => ({}));

export const MenuList = React.forwardRef<HTMLUListElement, MenuListProps>(
  function MenuList(props, ref) {
    return <MenuListRoot {...props} ref={ref} />;
  }
) as ExtendList<MenuListTypeMap<{}, "ul">>;
